import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppNotificationsService } from './../../../core/notifications/app-notifications.service';
import { AppLoaderService } from '../../../@theme/shared/services/app-loader/app-loader.service';
import { HiringRequestApprovalCommandDTO, HiringRequestApprovalsService } from '../hiring-request-approvals.service';
import { HiringRequestDialogData } from '../../hiring-request-editor/hiring-request-editor.component';
import { EmailEditorDTO, EmptyEmailEditorDTO } from '../../../shared/email/models/api-models';
import { SabisButton2Component, SabisNgxDialogComponent } from 'sabis-components2';
import { CardViewComponent } from 'src/app/shared/card-view/card-view.component';
import { SabisTextEditor2Component } from 'sabis-editor2';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'sca-hiring-request-approval-editor',
  templateUrl: './hiring-request-approval-editor.component.html',
  styleUrls: ['./hiring-request-approval-editor.component.scss'],
  imports: [
    SabisNgxDialogComponent,
    SabisButton2Component,
    CardViewComponent,
    SabisTextEditor2Component,
    FormsModule
  ]
})
export class HiringRequestApprovalEditorComponent {
  private _hiringRequestId: number | undefined;
  public approvalActionId: number | undefined;
  public reason: string = "";
  public title: string = 'Test Component';
  public email: EmailEditorDTO = EmptyEmailEditorDTO;

  constructor(
    public dialogRef: MatDialogRef<HiringRequestApprovalEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HiringRequestDialogData,
    private _appNotification: AppNotificationsService,
    private _appLoader: AppLoaderService,
    private _hiringrequestApprovalService: HiringRequestApprovalsService,
  ) {
    this.title = 'Hiring Request Approval';
  }

  ngOnInit(): void {
    this._hiringRequestId = this.data.hiringRequestId;
    this.approvalActionId = this.data.approvalActionId;
  }

  public onApproveClick(): void {
    if (!this._hiringRequestId) {
      return;
    }

    this._appLoader.showLoader('Approving...please wait');

    let data: HiringRequestApprovalCommandDTO = {
      rejectionReason: undefined
    };

    this._hiringrequestApprovalService.approveHiringRequest(this._hiringRequestId, data).subscribe({
      next: _ => {
        this._appLoader.hideLoader();
        this.dialogRef.close(true);
      },
      error: (ex) => {
        this._appNotification.unexpectedErrorOccurred();
        this._appLoader.hideLoader();
      },
      complete: () => {
        this._appLoader.hideLoader();
      }
    });
  }

  public onCancelClick(): void {
    this.dialogRef.close();
  }

  public onRejectClick(): void {
    if (this.reason.trim() === "" || this.reason === undefined) {
      this._appNotification.showInvalidEntriesMessage();
      return;
    }
    if (!this._hiringRequestId) {
      return;
    }
    this._appLoader.showLoader('Rejecting...please wait');

    let data: HiringRequestApprovalCommandDTO = {
      rejectionReason: this.reason
    };

    this._hiringrequestApprovalService.rejectHiringRequest(this._hiringRequestId!, data).subscribe({
      next: _ => {
        this._appLoader.hideLoader();
        this.dialogRef.close(true);
      },
      error: (ex) => {
        this._appNotification.unexpectedErrorOccurred();
        this._appLoader.hideLoader();
      },
      complete: () => {
        this._appLoader.hideLoader();
      }
    });
  }
}
